import React, { useState, useEffect } from 'react'
import { Alert, Button, Form, Input, Modal, notification, Radio, Select } from "antd"
import queryString from "query-string"
import { createBatchByNumberV3, listLevels, listPartner } from "../../../services/api/3dApi"
import { DropdownItem } from 'reactstrap'

const { Option } = Select

const BatchRecycle = ({ selectedBatchId, items, getItemColorSystemError, onResetSelected, isOpen, onCloseModal, onShowModal }) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [validate, setValidate] = useState('')
    const [user, setUser] = useState('')
    const [level, setLevel] = useState('1')
    const [levels, setLevels] = useState([])
    const [partner, setPartner] = useState('')
    const [partners, setPartners] = useState([])
    const [errLevels, setErrLevels] = useState('')
    const [errPartner, setErrPartner] = useState('')

    let listItemSelected = []

    items.map(item => {
        if (selectedBatchId.includes(item._id)) {
            return listItemSelected.push(item.item)
        } else {
            return null
        }
    })

    function openModal() {
        setLoading(false)
        onShowModal()
        setError('')
        setValidate('')
    }

    function cancelModal() {
        setLoading(false)
        onCloseModal()
        setError('')
        setValidate('')
    }

    function handleChangeUser(e) {
        const { value } = e.target

        setUser(value)
    }

    function handleChangeLevel(e) {
        const { value } = e.target

        setLevel(value)
    }

    function _handleChangeSelectPartner(value) {
        setPartner(value)
    }

    async function _onRecycleBatch() {
        setError('')
        setLoading(true)

        try {
            if (user === undefined || user === '') {
                setLoading(false)
                return setValidate('Vui lòng nhập vào người tái tạo lô.')
            }

            const params = {
                templates: listItemSelected.map(item => item.marketplace + '_' + item.item_number),
                user_create: user,
                level: level,
                partner: partner
            }

            const { data: response } = await createBatchByNumberV3(params)

            const { success, error, data } = response

            if (!success) {
                setLoading(false)
                return setError(error)
            }

            cancelModal()

            if (data.batch._id) {
                const win = window.open(`/batches/${data.batch._id}`, "_blank")
                win.focus()
            }

            if (!!data.errorMessages && data.errorMessages.length > 0) {
                notification.error({
                    message: 'Lỗi',
                    description: data.errorMessages.map((item, index) => {
                        return <p className='mb-0' key={index}>{item}</p>
                    })
                })
            }

            onResetSelected()
            getItemColorSystemError()
        } catch (e) {
            setLoading(false)
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    async function fetchLevel() {
        try {
            const { data: res } = await listLevels()

            const { success, error, data } = res

            if (!success) return setLevels(error)

            setLevels(data)
            setErrLevels('')
        } catch (e) {
            setErrLevels(e.message)
        }
    }

    async function fetchPartner() {
        try {
            const payload = { type: 'print_partner' }
            const query = queryString.stringify(payload)

            const { data: res } = await listPartner(query)

            const { success, error, data } = res

            if (!success) return setErrPartner(error)

            setPartners(data.partners)
            setErrPartner('')
        } catch (e) {
            setErrPartner(e.message)
        }
    }

    useEffect(() => {
        if (isOpen) {
            fetchLevel()
            fetchPartner()
        }
    }, [])

    return (
        <div className="BatchRecycle">
            <DropdownItem onClick={openModal} loading={loading}>
                Tái tạo lô
            </DropdownItem>
            <Modal
                visible={isOpen}
                title="Tái tạo lô"
                onOk={_onRecycleBatch}
                onCancel={cancelModal}
                footer={[
                    <Button key="back" onClick={cancelModal}>
                        Hủy
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={_onRecycleBatch}>
                        Tái tạo
                    </Button>
                ]}
            >
                {error && <Alert message={error} type='error' className='mb-3' />}

                <Form.Item
                    label='Tên người tái tạo lô'
                    validateStatus={validate && 'error'}
                    help={validate}
                >
                    <Input value={user} onChange={handleChangeUser} />
                </Form.Item>

                <Form.Item
                    label='Chọn đối tác'
                    validateStatus={errPartner && 'error'}
                    help={errPartner}
                >
                    <Select
                        onChange={_handleChangeSelectPartner}
                        defaultValue={partner}
                        dropdownClassName='custom-select-partner'
                    >
                        <Option value=''>---Hãy chọn một đối tác---</Option>
                        {
                            partners.length > 0 && partners.map(item => {
                                return <Option key={item._id} value={item._id}>{item.name}</Option>
                            })
                        }
                    </Select>
                </Form.Item>

                <Form.Item
                    label='Độ ưu tiên của lô'
                    validateStatus={errLevels && 'error'}
                    help={errLevels}
                >
                    <Radio.Group onChange={handleChangeLevel} defaultValue={level}>
                        {
                            levels.length > 0 && levels.map(item => {
                                return <Radio key={item.key} value={item.key}>{item.value}</Radio>
                            })
                        }
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    label='Danh sách item được tái tạo'
                >
                    <div className="ListItemSelected">
                        {
                            !!listItemSelected && listItemSelected.length > 0 && listItemSelected.map(item => (
                                <span key={item._id}>{`#${item.marketplace}_${item.item_number}`}</span>
                            ))
                        }
                    </div>

                    <span className='float-right'>Đã chọn: <strong>{listItemSelected.length || 0}</strong> items</span>
                </Form.Item>
            </Modal>
        </div>
    )
}

export default BatchRecycle
